import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import './Business.js';
import { a as BusinessFormClickActions } from './event-types.js';
import { B as Button } from './button.js';
import './details.js';

const PaymentProvisioningFormButtons = /*@__PURE__*/ proxyCustomElement(class PaymentProvisioningFormButtons extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.currentStep = undefined;
        this.totalSteps = undefined;
        this.formLoading = undefined;
        this.formDisabled = undefined;
        this.previousStepButtonOnClick = undefined;
        this.nextStepButtonOnClick = undefined;
    }
    get showPreviousStepButton() {
        return this.currentStep > 0;
    }
    get showNextStepButton() {
        return this.currentStep < this.totalSteps;
    }
    get showSubmitButton() {
        return this.currentStep === this.totalSteps;
    }
    render() {
        return (h("div", { key: 'f5b14768cd97673e77c1ee2d9d73221cdee885e6', class: 'd-flex gap-2' }, h(Button, { key: '4726571002718d036c292a41dc216955ba5ec687', variant: "secondary", type: "button", onClick: () => this.previousStepButtonOnClick(), disabled: this.formDisabled, hidden: !this.showPreviousStepButton }, "Previous"), h(Button, { key: '3852cfcd4704f5509f22a5c457526fe8475df096', variant: "primary", type: "button", onClick: (e) => this.nextStepButtonOnClick(e, BusinessFormClickActions.nextStep), disabled: this.formDisabled, isLoading: this.formLoading, hidden: !this.showNextStepButton }, "Next"), h(Button, { key: 'd62830b61932581071a1a44d872760be0823215a', variant: "primary", type: "submit", onClick: (e) => this.nextStepButtonOnClick(e, BusinessFormClickActions.submit), disabled: this.formDisabled, isLoading: this.formLoading, hidden: !this.showSubmitButton }, "Submit")));
    }
}, [0, "justifi-payment-provisioning-form-buttons", {
        "currentStep": [2, "current-step"],
        "totalSteps": [2, "total-steps"],
        "formLoading": [4, "form-loading"],
        "formDisabled": [4, "form-disabled"],
        "previousStepButtonOnClick": [16],
        "nextStepButtonOnClick": [16]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-payment-provisioning-form-buttons"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-payment-provisioning-form-buttons":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PaymentProvisioningFormButtons);
            }
            break;
    } });
}
defineCustomElement();

export { PaymentProvisioningFormButtons as P, defineCustomElement as d };
